import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import type { SupabaseClient } from '@supabase/supabase-js';
import { PartnersAuthProvider, usePartnersAuth } from '@partners/auth/PartnersAuth';
import { Gate } from '@partners/routes/Gate';
import { SignIn } from '@partners/routes/SignIn';

/** Signed out: everything but /signin goes there. Before the stored session is read: nothing (no flash). */
function RequireSession() {
  const { session, ready } = usePartnersAuth();
  if (!ready) return null;
  if (!session) return <Navigate to="/signin" replace />;
  return <Gate />;
}

export function PartnersRoutes() {
  return (
    <Routes>
      <Route path="/signin" element={<SignIn />} />
      <Route path="*" element={<RequireSession />} />
    </Routes>
  );
}

/** The promoter portal (web/partners): its own auth layer over the shared client, two routes. */
export function PartnersApp({ client }: { client: SupabaseClient }) {
  return (
    <BrowserRouter>
      <PartnersAuthProvider client={client}>
        <PartnersRoutes />
      </PartnersAuthProvider>
    </BrowserRouter>
  );
}
